export default "__VITE_ASSET__C191Rgq0__"